import React from 'react';
import { Globe } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';
import { Language } from '../i18n/translations';
const languages: {
  code: Language;
  label: string;
}[] = [{
  code: 'en',
  label: 'EN'
}, {
  code: 'es',
  label: 'ES'
}, {
  code: 'fr',
  label: 'FR'
}, {
  code: 'ru',
  label: 'RU'
}];
export function LanguageSwitcher() {
  const {
    lang,
    setLang
  } = useLanguage();
  return <div className="fixed top-4 left-1/2 -translate-x-1/2 z-50" data-id="element-134">
      <div className="flex items-center gap-1 p-1 bg-black/60 backdrop-blur-md border border-white/10 rounded-full shadow-xl" data-id="element-135">
        <div className="flex items-center gap-2 pl-4 pr-2 text-white/60" data-id="element-136">
          <Globe className="w-4 h-4" data-id="element-137" />
          <span className="text-xs font-medium uppercase tracking-wider hidden sm:inline" data-id="element-138">
            Language
          </span>
        </div>
        {languages.map(l => <button key={l.code} onClick={() => setLang(l.code)} className={`px-3 py-1.5 text-xs font-medium rounded-full transition-colors ${lang === l.code ? 'bg-magenta-500 text-white shadow-md' : 'text-white/70 hover:text-white hover:bg-white/10'}`} data-id="element-139">
            {l.label}
          </button>)}
      </div>
    </div>;
}